const menuItemTypes = {
    FETCH_MENUITEM_START :'FETCH_MENUITEM_START',
    FETCH_MENUITEM_SUCCESS :'FETCH_MENUITEM_SUCCESS',
    FETCH_MENUITEM_FAILURE :'FETCH_MENUITEM_FAILURE',
}

export default menuItemTypes;